import React from 'react';
import { DayOfWeek } from '../../../models/day-enum';
import { ScheduleTimeCell } from '@med-fe/ui';
import moment from 'moment';

const scheduleBaseColumns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 120,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 250,
  },
  {
    title: 'timezone',
    dataIndex: 'timezone',
    key: 'timezone',
    width: 60,
  },
  {
    title: 'Effective date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    width: 135,
  },
  {}, // empty column, workaround to have column width fixed
];

const scheduleDays = [
  DayOfWeek.Monday,
  DayOfWeek.Tuesday,
  DayOfWeek.Wednesday,
  DayOfWeek.Thursday,
  DayOfWeek.Friday,
  DayOfWeek.Saturday,
  DayOfWeek.Sunday,
];

export const getScheduleColumns = (scheduleSubtab = 'current', selectedDate = moment()) => {
  const isCore = scheduleSubtab === 'core';
  const weekStart = isCore ? moment(selectedDate).startOf('day').day(0) : moment(selectedDate).startOf('isoWeek');
  const days = isCore ? [DayOfWeek.Sunday, ...scheduleDays.slice(0, 6)] : scheduleDays;
  const todayIndex = moment().diff(weekStart, 'days');
  const dayColumns = days.map((day, index) => {
    const isTodayColumn = scheduleSubtab === 'current' && index === todayIndex && todayIndex >= 0 && todayIndex < 7;

    return {
      title:
        scheduleSubtab === 'current'
          ? `${day.slice(0, 3).toUpperCase()} ${weekStart.clone().add(index, 'days').format('MMM D')}${
              isTodayColumn ? ' (TODAY)' : ''
            }`
          : day,
      dataIndex: day,
      key: day,
      width: 135,
      align: 'center',
      ...(scheduleSubtab === 'current' && {
        onHeaderCell: () => ({
          style: {
            fontWeight: 700,
            ...(isTodayColumn && { backgroundColor: '#DCEEFF' }),
          },
        }),
      }),
      ...(isTodayColumn && {
        onCell: () => ({ style: { backgroundColor: '#EEF6FF' } }),
      }),
      render: (cell: any) => <ScheduleTimeCell value={cell?.value} isTemporaryClosed={cell?.isTemporaryClosed} />,
    };
  });

  return scheduleSubtab === 'core'
    ? [...scheduleBaseColumns.slice(0, 3), ...dayColumns, scheduleBaseColumns[scheduleBaseColumns.length - 1]]
    : [...scheduleBaseColumns.slice(0, 3), ...dayColumns, ...scheduleBaseColumns.slice(3)];
};

export const schedule_columns = getScheduleColumns();
